module.exports = __webpack_public_path__ + "img/sv18.819808b1.svg";